import { api } from './client';

export interface SisAnalyticsKpis {
  totalSales: number;
  totalUnits: number;
  avgSellPrice: number;
  profitabilityPct: number;
  stores: number;
  bestStore: string;
}

export interface SisStoreRank {
  partyId: number;
  name: string;
  group: string;
  area: number;
  netSales: number;
  units: number;
  salesPerSqft: number | null;
  profitabilityPct: number;
}

export interface SisSkuRank {
  itemId: number;
  code: string;
  name: string;
  category: string;
  netSales: number;
  units: number;
}

export interface SisCatRank {
  category: string;
  netSales: number;
  units: number;
}

export interface SisAnalytics {
  kpis: SisAnalyticsKpis;
  byStore: SisStoreRank[];
  topSkus: SisSkuRank[];
  bottomSkus: SisSkuRank[];
  byCategory: SisCatRank[];
}

export async function getSisAnalytics(filter: { from?: string; to?: string; group?: string } = {}): Promise<SisAnalytics> {
  const r = await api.get<SisAnalytics>('/sis-stock/analytics', { params: filter });
  return r.data;
}
